import React from 'react';
import { Link, LinkProps as RouterLinkProps } from 'react-router-dom';
import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';
import type { LinkProps } from '@mui/material/Link';
import type { ButtonBaseProps } from '@mui/material/ButtonBase';

type LinkBehaviorProps = Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
const LinkBehavior: React.ForwardRefExoticComponent<LinkBehaviorProps> = React.forwardRef<HTMLAnchorElement, LinkBehaviorProps>((props, ref) => {
	const { href, ...other } = props;
	return <Link ref={ref} to={href} {...other} />;
});
LinkBehavior.displayName = 'LinkBehavior';

export const ComponentThemes: Components<Omit<Theme, 'components'>> = {
	MuiCssBaseline: {
		styleOverrides: {
			'html[data-mui-color-scheme] *': { transition: 'background-color 300ms ease, color 300ms ease' },
			body: {
				background: 'linear-gradient(160deg, #161618 0%, #0e0e10 40%, #111113 100%)',
				backgroundAttachment: 'fixed',
				minHeight: '100vh',
				color: 'var(--mui-palette-text-primary)',
			},
			'#root': {
				'> main:first-of-type > :first-child': { paddingTop: 'max(100px, 10vh + 25px)' }
			},
		},
	},
	MuiLink: {
		defaultProps: {
			component: LinkBehavior,
		} as LinkProps,
	},
	MuiButtonBase: {
		defaultProps: {
			LinkComponent: LinkBehavior,
		} as ButtonBaseProps,
	},
};
